import classnames from 'classnames';
import React from 'react';

import { faqsResourceDefinition } from 'dpl/breeder_search_results/utils/queryDefinitions';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { FaqsResponse } from 'dpl/breeder_search_results/constants/resource_types';

interface FAQModuleProps {
  className?: string | null;
  breedId: string | number;
  citySlug: string;
}

export default function FAQModule({
  className = null,
  breedId,
  citySlug
}: FAQModuleProps) {
  const {
    value: { data: questions }
  } = useResourceQuery<FaqsResponse>(faqsResourceDefinition(breedId, citySlug));

  if (questions.length === 0) return null;

  return (
    <div className={classnames('FAQModule', className)}>
      <h5 className="font-20 md:font-32 lg:font-40 mb2 mb4-md mb6-lg lh-title">
        Frequently asked questions
      </h5>
      <ol style={{ maxWidth: '844px' }}>
        {questions.map(({ question, answer }: any, index: number) => (
          <li
            key={index}
            className={classnames({ 'bt b--default': index > 0 })}
          >
            <div className="pv6 pv8-md">
              <h6 className="font-16 md:font-24 font-sans xs:font-sans md:font-serif fw-medium lh-title mb3">
                {question}
              </h6>
              <p
                /* eslint-disable-next-line react/no-danger */
                dangerouslySetInnerHTML={{ __html: answer }}
                className="font-16 md:font-18 lh-title secondary"
              />
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
